<div class="blur-content">
  <div class="page-container" style="background-color: #f2f8fa !important">
    <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
    <div class="main-content">
      <app-header></app-header>
      <div class="main-content-inner">
        <div class="row mt-5">
          <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
            <div class="card">
              <div class="card-body">
                <div class="header-section">
                  <h4>Ask a Person</h4>
                </div>

                <!-- Loading -->
                <div *ngIf="loading" class="d-flex justify-content-center">
                  <div class="spinner-border m-5" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <!-- Table -->
                <div class="table-responsive" *ngIf="!loading && records.length" style="overflow-x: auto;">
                  <table class="table table-bordered table-hover table-striped align-middle mb-0 bg-white">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Department</th>
                        <th>Question</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Note</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let record of records">
                        <td>{{ record.userId }}</td>
                        <td>{{ record.firstName }}</td>
                        <td>{{ record.lastName }}</td>
                        <td>{{ record.department }}</td>
                        <td>{{ record.question }}</td>
                        <td>{{ formatDate(record.createdAt) }}</td>
                        <td>
                          <select class="custom-select custom-select-sm status-dropdown"
                                  [(ngModel)]="record.status"
                                  (ngModelChange)="onStatusChange(record)">
                            <option value="New">New</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Done">Done</option>
                          </select>
                        </td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-icon btn-note" (click)="openNoteModal(record)" title="Add/Edit Note">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                              <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4z"/>
                            </svg>
                          </button>
                        </td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-icon btn-delete" (click)="deleteRecord(record.id)" title="Delete">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                              <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div *ngIf="!loading && records.length === 0" class="text-center">No data</div>

                <!-- Pagination -->
                <div *ngIf="!loading && records.length > 0" class="pagination-container">
                  <ngb-pagination
                    [collectionSize]="collectionSize"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    [maxSize]="4"
                    [boundaryLinks]="true"
                    [rotate]="true"
                    (pageChange)="onPageChange($event)"
                    class="paginationSet">
                  </ngb-pagination>

                  <div class="select-wrapper">
                    <select class="form-select"
                            [(ngModel)]="pageSize"
                            (ngModelChange)="onPageSizeChange($event)">
                      <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">
                        {{ opt }} items per page
                      </option>
                    </select>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<app-confirmation-modal
  [isVisible]="showDeleteModal"
  (isVisibleChange)="showDeleteModal = $event"
  title="Delete Record"
  message="Are you sure you want to delete this record?"
  note="(Note: This action cannot be undone)"
  confirmButtonText="Delete"
  cancelButtonText="Cancel"
  [loading]="deleting"
  [successMessage]="deleteSuccessMessage"
  (confirm)="confirmDelete()"
  (cancel)="closeDeleteModal()"
  (close)="closeDeleteModal()">
</app-confirmation-modal>

<!-- Note Modal -->
<div class="modal-overlay" *ngIf="showNoteModal" (click)="closeNoteModal()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h5 class="modal-title-custom">Add / Edit Note</h5>
      <button class="modal-close" (click)="closeNoteModal()">&times;</button>
    </div>
    <hr style="margin: 0;">
    <div class="modal-body-custom">
      <label class="modal-label">Note</label>
      <textarea class="form-control" [(ngModel)]="noteText" placeholder="Enter note" rows="4"></textarea>
    </div>
    <div class="modal-footer-custom">
      <button class="btn btn-submit" (click)="saveNote()" [disabled]="savingNote">
        {{ savingNote ? 'Saving...' : 'Save' }}
      </button>
      <button class="btn btn-close-modal" (click)="closeNoteModal()">Close</button>
    </div>
  </div>
</div>
